import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
export const GlobalAdminHealthcareOrganizationUserListViewParent = styled.div ``;
export const UserTable = styled.table `
    font-size: ${fontSizes.SMALL};
    margin-top: 5px;
    width: 100%;
    border: 2px solid ${colors.black_30};
    border-collapse: collapse;
    & th {
        text-align: left;
    }

    & th,
    td {
        padding: 8px 10px;
        vertical-align: middle;
    }

    & tbody tr:nth-child(odd) {
        background-color: ${colors.black_4};
    }
`;
export const ActionTableCell = styled.td `
    width: 200px;
    text-align: right;
`;
